var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { Component } from "react";
import parseItem from "../../../functions/ParseItem";
import ItemFunctions from "../../../functions/ItemFunctions";
import priceCalculations from "../../../functions/priceCalculations";
import ModifierFunctions from "../../../functions/ModifierFunctions";
import AddOnItemFunctions from "../../../functions/AddOnItemFunctions";
import { bugsnagClient } from "../../../themes/streamlined/streamlined";
import { shouldDisplayMenuEntity } from "../../utility/menuItemVisibility";
export var ItemContext = React.createContext({});
var parseInitialItemChoices = function (value) {
    if (value && typeof value === "object") {
        return value;
    }
    if (typeof value !== "string" || value.trim() === "") {
        return null;
    }
    try {
        var parsedValue = JSON.parse(value);
        return parsedValue && typeof parsedValue === "object" ? parsedValue : null;
    }
    catch (_error) {
        return null;
    }
};
var Item = /** @class */ (function (_super) {
    __extends(Item, _super);
    function Item(props) {
        var _a;
        var _this = _super.call(this, props) || this;
        var editWindow = window;
        var initialComment = editWindow.editLineID && typeof editWindow.editLineComment === "string" ? editWindow.editLineComment : "";
        _this.state = {
            loading: true,
            hasPopupError: false,
            hasServerError: false,
            quantity: 1,
            isValid: true,
            comment: initialComment,
            serviceTypeName: (_a = window.session) === null || _a === void 0 ? void 0 : _a.service_type_name,
            itemAdded: false,
            functions: {
                selectMainItem: ItemFunctions.selectMainItem.bind(_this),
                calculateSubtotal: priceCalculations.calculateSubtotal.bind(_this),
                processSubmitAttempt: ItemFunctions.processSubmitAttempt.bind(_this),
                determineExcludedModifiers: ModifierFunctions.determineExcludedModifiers.bind(_this),
                determineIncludedModifiers: ModifierFunctions.determineIncludedModifiers.bind(_this),
                reAddIncludedItem: ModifierFunctions.reAddIncludedItem.bind(_this),
                excludeIncludedItem: ModifierFunctions.excludeIncludedItem.bind(_this),
                setFirstHalfOnly: ModifierFunctions.setFirstHalfOnly.bind(_this),
                setSecondHalfOnly: ModifierFunctions.setSecondHalfOnly.bind(_this),
                setWholePortion: ModifierFunctions.setWholePortion.bind(_this),
                setExtra: ModifierFunctions.setExtra.bind(_this),
                setLight: ModifierFunctions.setLight.bind(_this),
                setNormalSize: ModifierFunctions.setNormalSize.bind(_this),
                removeOptionalModifier: ModifierFunctions.removeOptionalModifier.bind(_this),
                handleModifierQuantityChange: ModifierFunctions.handleModifierQuantityChange.bind(_this),
                increaseModifierQuantity: ModifierFunctions.increaseModifierQuantity.bind(_this),
                decreaseModifierQuantity: ModifierFunctions.decreaseModifierQuantity.bind(_this),
                handleChangeToItemComment: ItemFunctions.handleChangeToItemComment.bind(_this),
                increaseItemQuantity: ItemFunctions.increaseItemQuantity.bind(_this),
                decreaseItemQuantity: ItemFunctions.decreaseItemQuantity.bind(_this),
                numberOfSelections: ItemFunctions.numberOfSelections.bind(_this),
                markAsValid: ItemFunctions.markAsValid.bind(_this),
                markAsInvalid: ItemFunctions.markAsInvalid.bind(_this),
                chooseAddOnItem: AddOnItemFunctions.chooseAddOnItem.bind(_this),
                decreaseAddOnQuantity: AddOnItemFunctions.decreaseAddOnQuantity.bind(_this),
                increaseAddOnQuantity: AddOnItemFunctions.increaseAddOnQuantity.bind(_this),
                removeAddOnItem: AddOnItemFunctions.removeAddOnItem.bind(_this),
                setModifierQuantity: function (modifierId, quantity) {
                    _this.setState(function (previous) {
                        var nextChoices = __assign(__assign({}, previous.choices), { modifiers: __assign({}, previous.choices.modifiers) });
                        var existing = nextChoices.modifiers[modifierId] || { portion: "whole", size: "normal", quantity: 0 };
                        nextChoices.modifiers[modifierId] = __assign(__assign({}, existing), { quantity: quantity });
                        return { choices: nextChoices };
                    });
                }
            }
        };
        _this.parseItem = parseItem.bind(_this);
        _this.submitCustomization = ItemFunctions.submitCustomization.bind(_this);
        _this.calculatePriceForAddons = priceCalculations.calculatePriceForAddons.bind(_this);
        _this.calculatePriceForMatrixPricing = priceCalculations.calculatePriceForMatrixPricing.bind(_this);
        _this.calculatePriceForPriceLevels = priceCalculations.calculatePriceForPriceLevels.bind(_this);
        _this.calculateSubtotalWithoutAddons = priceCalculations.calculateSubtotalWithoutAddons.bind(_this);
        _this.getModifierPriceForPriceLevel = priceCalculations.getModifierPriceForPriceLevel.bind(_this);
        _this.getIncludedModifierPriceForPriceLevel = priceCalculations.getIncludedModifierPriceForPriceLevel.bind(_this);
        _this.getModifierPriceForChoice = priceCalculations.getModifierPriceForChoice.bind(_this);
        _this.getTotalMatrixWeightForChosenIncluded = priceCalculations.getTotalMatrixWeightForChosenIncluded.bind(_this);
        _this.getTotalMatrixWeightForChosenModifier = priceCalculations.getTotalMatrixWeightForChosenModifier.bind(_this);
        return _this;
    }
    Item.prototype.parseVisibleItem = function (item, category) {
        var _a, _b;
        if (!shouldDisplayMenuEntity(item)) {
            this.setState({ no_items: true, loading: false });
            return;
        }
        var mainItems = Array.isArray((_a = item === null || item === void 0 ? void 0 : item.item_group) === null || _a === void 0 ? void 0 : _a.items) ? item.item_group.items : [];
        var visibleMainItemIndex = mainItems.findIndex(function (mainItem) { return shouldDisplayMenuEntity(mainItem); });
        if (visibleMainItemIndex < 0) {
            this.setState({ no_items: true, loading: false });
            return;
        }
        this.parseItem(item, category);
        var editWindow = window;
        var initialChoices = parseInitialItemChoices(this.props.initialChoices)
            || parseInitialItemChoices(editWindow.editItemChoices);
        var selectedIndex = Number((_b = initialChoices === null || initialChoices === void 0 ? void 0 : initialChoices.item) !== null && _b !== void 0 ? _b : 0);
        if (initialChoices && !shouldDisplayMenuEntity(mainItems[selectedIndex])) {
            this.setState({ no_items: true, loading: false });
            return;
        }
        this.setState(function (previousState) {
            var _a;
            return (__assign({ itemGroup: __assign(__assign({}, previousState.itemGroup), { items: (((_a = previousState.itemGroup) === null || _a === void 0 ? void 0 : _a.items) || []).map(function (mainItem, itemIndex) {
                        var _a;
                        return (__assign(__assign({}, mainItem), { is_core: (_a = mainItems[itemIndex]) === null || _a === void 0 ? void 0 : _a.is_core }));
                    }) }) }, (!initialChoices && visibleMainItemIndex !== 0 ? {
                choices: __assign(__assign({}, previousState.choices), { item: visibleMainItemIndex }),
            } : {})));
        });
    };
    Item.prototype.componentDidMount = function () {
        var _this = this;
        var _a, _b, _c;
        if (this.props.initialItemPayload) {
            // eslint-disable-next-line no-console
            console.info("[ItemCustomization] Using provided item payload", {
                debugContext: this.props.debugContext,
                itemPayload: this.props.initialItemPayload,
            });
            bugsnagClient.leaveBreadcrumb("Using provided item customization payload.", {
                debugContext: this.props.debugContext,
                itemPayload: this.props.initialItemPayload,
            });
            if (((_c = (_b = (_a = this.props.initialItemPayload.item) === null || _a === void 0 ? void 0 : _a.item_group) === null || _b === void 0 ? void 0 : _b.items) === null || _c === void 0 ? void 0 : _c.length) < 1) {
                this.setState({ no_items: true, loading: false });
                return;
            }
            this.parseVisibleItem(this.props.initialItemPayload.item, this.props.initialItemPayload.category);
            return;
        }
        var itemURL = this.props.apiUrl ? "".concat(this.props.apiUrl) : "".concat(document.location);
        itemURL = itemURL.replace("?", "");
        itemURL = itemURL.replace("#", "");
        var itemApiUrl = "".concat(itemURL, "/api");
        var itemCustomizationDebugContext = {
            itemUrl: itemURL,
            itemApiUrl: itemApiUrl,
            currentLocation: window.location.href,
            debugContext: this.props.debugContext,
        };
        // eslint-disable-next-line no-console
        console.info("[ItemCustomization] Loading item API", itemCustomizationDebugContext);
        bugsnagClient.leaveBreadcrumb("Loading item customization API.", itemCustomizationDebugContext);
        fetch(itemApiUrl).then(function (response) { return __awaiter(_this, void 0, void 0, function () {
            var responseText, responseJson, parseErrorContext_1, missingDataContext_1, httpErrorContext;
            var _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (response.status > 300 && response.status < 400) {
                            document.location.reload();
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, response.text()];
                    case 1:
                        responseText = _d.sent();
                        responseJson = null;
                        if (responseText) {
                            try {
                                responseJson = JSON.parse(responseText);
                            }
                            catch (error) {
                                parseErrorContext_1 = {
                                    itemApiUrl: itemApiUrl,
                                    status: response.status,
                                    responseText: responseText,
                                    responseUrl: response.url,
                                    debugContext: this.props.debugContext,
                                };
                                // eslint-disable-next-line no-console
                                console.error("[ItemCustomization] Unable to parse item API response", parseErrorContext_1);
                                bugsnagClient.leaveBreadcrumb("Unable to parse item customization API response.", parseErrorContext_1);
                                bugsnagClient.notify(error, function (event) {
                                    event.addMetadata("itemCustomization", parseErrorContext_1);
                                });
                                this.setState({ loading: false, hasServerError: true });
                                return [2 /*return*/];
                            }
                        }
                        if (response.ok) {
                            if (((_c = (_b = (_a = responseJson === null || responseJson === void 0 ? void 0 : responseJson.item) === null || _a === void 0 ? void 0 : _a.item_group) === null || _b === void 0 ? void 0 : _b.items) === null || _c === void 0 ? void 0 : _c.length) < 1) {
                                this.setState({ no_items: true, loading: false });
                                return [2 /*return*/];
                            }
                            if (!(responseJson === null || responseJson === void 0 ? void 0 : responseJson.item) || !(responseJson === null || responseJson === void 0 ? void 0 : responseJson.category)) {
                                missingDataContext_1 = {
                                    itemApiUrl: itemApiUrl,
                                    status: response.status,
                                    responseJson: responseJson,
                                    responseUrl: response.url,
                                    debugContext: this.props.debugContext,
                                };
                                // eslint-disable-next-line no-console
                                console.error("[ItemCustomization] Item API response missing expected data", missingDataContext_1);
                                bugsnagClient.leaveBreadcrumb("Item customization API response missing expected data.", missingDataContext_1);
                                bugsnagClient.notify(new Error("Item customization API response missing expected data."), function (event) {
                                    event.addMetadata("itemCustomization", missingDataContext_1);
                                });
                                this.setState({ loading: false, hasServerError: true });
                                return [2 /*return*/];
                            }
                            this.parseVisibleItem(responseJson.item, responseJson.category);
                            return [2 /*return*/];
                        }
                        httpErrorContext = {
                            itemApiUrl: itemApiUrl,
                            status: response.status,
                            responseText: responseText,
                            responseJson: responseJson,
                            responseUrl: response.url,
                            debugContext: this.props.debugContext,
                        };
                        // eslint-disable-next-line no-console
                        console.error("[ItemCustomization] Item API HTTP failure", httpErrorContext);
                        bugsnagClient.leaveBreadcrumb("Error loading item customization API.", httpErrorContext);
                        bugsnagClient.notify(new Error("Item customization API failed with ".concat(response.status, ".")), function (event) {
                            event.addMetadata("itemCustomization", httpErrorContext);
                        });
                        this.setState({ error: responseJson, loading: false, hasServerError: response.status !== 422 });
                        return [2 /*return*/];
                }
            });
        }); }, function (error) {
            var rejectionContext = {
                itemApiUrl: itemApiUrl,
                errorMessage: error === null || error === void 0 ? void 0 : error.message,
                debugContext: _this.props.debugContext,
            };
            // eslint-disable-next-line no-console
            console.error("[ItemCustomization] Item API request rejected", rejectionContext);
            bugsnagClient.leaveBreadcrumb("Item customization API request rejected.", rejectionContext);
            bugsnagClient.notify(error, function (event) {
                event.addMetadata("itemCustomization", rejectionContext);
            });
            _this.setState({ loading: false, hasServerError: true });
        });
    };
    Item.prototype.render = function () {
        return React.createElement(ItemContext.Provider, { value: this.state }, this.props.content);
    };
    return Item;
}(Component));
export { Item };
